import { Package } from 'lucide-react';

const EmptyState = ({ 
  title = 'Heç nə tapılmadı', 
  description = 'Hal-hazırda göstəriləcək məhsul yoxdur.',
  icon: Icon = Package 
}) => {
  return (
    <div 
      className="flex flex-col items-center justify-center py-20 text-center"
      data-testid="empty-state"
    >
      <div className="w-24 h-24 rounded-full bg-brand-accent/30 flex items-center justify-center mb-6">
        <Icon className="w-12 h-12 text-brand-primary" />
      </div>
      <h3 className="font-serif text-2xl text-brand-brown mb-2">{title}</h3>
      <p className="text-brand-muted text-sm max-w-md">{description}</p>
    </div>
  );
};

export default EmptyState;
